import type { WebsiteAppearance } from "@/cms/appearance";

/**
 * With `logoOnDark: "inverse"` the dark scheme shows the inverse logo and the light scheme the standard one.
 * Null without the opt-in, so callers keep their own choice. Both are rendered and CSS shows the active scheme's.
 */
export function schemeLogos(
  appearance: WebsiteAppearance | undefined,
  standard: string | null | undefined,
  inverse: string | null | undefined,
): { dark: string; light: string } | null {
  if (appearance?.logoOnDark !== "inverse" || !standard) return null;
  return { dark: inverse || standard, light: standard };
}
